import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import { transformResultsToTableData } from "../../../../services/commonService";

function LogisticsDeliveryPerformance({ logisticsAndDeliveryPerformance }) {
  const [tabData, setTabData] = useState([]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  // useEffect(() => {
  //   const rawData = successMessage?.logistics_and_delivery_performance;
  //   const dummyData = rawData
  //     ? Object.entries(successMessage?.logistics_and_delivery_performance).map(
  //         ([competitor, details]) => ({
  //           competitor,
  //           lead_times: details["Lead Times"],
  //           warehouse_locations: details["Warehouse Locations"],
  //           supply_chain_risk_level: details["Supply Chain Risk Level"],
  //           lead_times_positive_insight: details["Lead Times"],
  //           lead_times_negative_insight: details["Lead Times"],
  //           lead_times_recent_development: details["Lead Times"],
  //           warehouse_locations_positive_insight:
  //             details["Warehouse Locations"],
  //           warehouse_locations_negative_insight:
  //             details["Warehouse Locations"],
  //           warehouse_locations_recent_development:
  //             details["Warehouse Locations"],
  //           supply_chain_risk_level_positive_insight:
  //             details["Supply Chain Risk Level"],
  //           supply_chain_risk_level_negative_insight:
  //             details["Supply Chain Risk Level"],
  //           supply_chain_risk_level_recent_development:
  //             details["Supply Chain Risk Level"],
  //         })
  //       )
  //     : [];
  //   setTabData(dummyData);
  // }, [successMessage]);

  useEffect(() => {
    const tableData = transformResultsToTableData(
      logisticsAndDeliveryPerformance
    );
    setTabData(tableData);
  }, [logisticsAndDeliveryPerformance]);

  const tableColumns = [
    // { key: "competitor", label: "Competitor" },
    { key: "lead_times", label: "Lead Times" },
    { key: "warehouse_locations", label: "Warehouse Locations" },
    { key: "supply_chain_risk_level", label: "Supply Chain Risk Level" },
  ];

  return (
    <InsightTable
      title="Logistics & Delivery Performance"
      subtitle="Compares warehousing networks, delivery times, and fulfillment resiliency across global operations."
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default LogisticsDeliveryPerformance;
